import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {AuthService} from '../../../core/service/auth.service';
import {DatesParserService} from '../../../core/service/dates_parser.service';
import {UserService} from '../../services/user.service';
import {User} from '../../model/user';
import {DatatableComponent} from '@swimlane/ngx-datatable';

@Component({
    selector: 'app-user-source',
    templateUrl: './user-source.component.html',
    styleUrls: ['./user-source.component.scss']
})
export class UserSourceComponent implements OnInit {

    formSearch: FormGroup;
    iniDate: Date;
    endDate: Date;
    sales: Array<Object>;
    isSelected: boolean;
    enabled: boolean;
    isSubmitted: boolean;
    users: Array<User>;
    temp: Array<User>;
    filenameSearch: string;


    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(private authService: AuthService, private datesParser: DatesParserService, private userSrv: UserService) {
        this.formSearch = new FormGroup(
            {
                'start_date': new FormControl('', Validators.required),
                'end_date': new FormControl('', Validators.required),
                'campaign': new FormControl('', Validators.required)
            }
        );
        this.iniDate = new Date();
        this.iniDate.setHours(0, 0, 0, 0);

        this.endDate = new Date();
        this.endDate.setHours(23, 59, 59, 0);

        this.sales = this.authService.getSales();
        this.isSelected = true;
        this.enabled = false;
        this.isSubmitted = false;

        this.filenameSearch = '';
        this.users = [];
    }

    /**
     * Search user sources
     */
    findUserSources() {
        this.isSubmitted = true;
        if (!this.formSearch.valid) {
            return false;
        }

        this.enabled = true;
        const query: Object = this.datesParser.cleanDates(this.formSearch.value, ['start_date', 'end_date']);
        console.log('query: ', query);

        this.userSrv.findUserSources(query).subscribe(
            data => {
                this.users = data;
                this.temp = [...data];
                this.enabled = false;
            }
        );
    }

    /**
     * Updates event for table search
     * @param event
     */
    updateFilter(event) {
        this.filenameSearch = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d.user_pk.toString().indexOf(this.filenameSearch) !== -1 || !this.filenameSearch;
        });

        this.users = temp;
        this.table.offset = 0;
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/user/components/user-source/user-source.component.ts